import { playDeliveryTake } from '../../assets/preloadSounds';
import type { NewDeliveryScreenModel } from './NewDeliveryScreenModelScreen';

export class NewDeliveryScreenController {
  constructor(private readonly model: NewDeliveryScreenModel) {}

  handleGoBack = () => {
    this.model.onGoBack?.();
  };

  handleTakeOrder = () => {
    if (!this.model.canTakeOrder) {
      return;
    }
    playDeliveryTake();
    this.model.onTakeOrder?.();
  };
}
